import type { PropsWithChildren, ReactNode } from "react";
import { Outlet } from "react-router";

import { useAuthLoginQuery } from "shared/api/use-auth-login-query";
import { Spinner } from "shared/ui/spinner";

import { AuthContext } from "./context";

type Props = {
  renderLoading?: () => ReactNode;
  renderError?: (error: Error) => ReactNode;
};

export const AuthProvider = ({
  children,
  renderError,
  renderLoading,
}: PropsWithChildren<Props>) => {
  const query = useAuthLoginQuery();

  if (query.isLoading)
    return renderLoading ? (
      renderLoading()
    ) : (
      <div className="flex min-h-dvh grow items-center justify-center">
        <Spinner />
      </div>
    );

  if (query.error)
    return renderError ? renderError(query.error) : <div>Error</div>;

  if (query.isSuccess)
    return (
      <AuthContext.Provider value={query.data}>
        {children ?? <Outlet />}
      </AuthContext.Provider>
    );

  return null;
};
